import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import LivingSpacesView from '../views/LivingSpacesView.vue'
import ReservationsView from '../views/ReservationsView.vue'
import RoomsView from '../views/RoomsView.vue'
import PraticalInformationsView from '@/views/PraticalInformationsView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/a-propos',
    name: 'about',
    component: AboutView
  },
  {
    path: '/espaces-a-vivre',
    name: 'living_spaces',
    component: LivingSpacesView
  },
  {
    path: '/reservations',
    name: 'disponibility',
    component: ReservationsView
  },
  {
    path: '/chambres',
    name: 'rooms',
    component: RoomsView
  },
  {
    path: '/infos-pratiques',
    name: 'particals_informations',
    component: PraticalInformationsView
  },
]



const router = createRouter({
  scrollBehavior() {
    return { top : 0}
    
  },
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
